import { isBuoyDevice } from '../features/ConnectedDevices/features/Buoy/utils/buoyDeviceUtils';
import { DeviceIsDeviceType } from './deviceComparisionUtils';

export const canViewDeviceType = (device, perms, visibleDeviceTypes) => {
  if (DeviceIsDeviceType(device, 'Stage'))
    return (
      perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewFloodStageConnections']) &&
      visibleDeviceTypes['Stage']
    );
  else if (device.device_type === 'Manual Road Closure')
    return (
      perms.testPermission(
        [8, 9, 10, 11, 12, 13],
        ['ViewRescAlertDevicesManualRoadClosureConnections'],
      ) && visibleDeviceTypes['Manual Road Closure']
    );
  else if (device.device_type === 'Technology Bridge_Flashing Lights')
    return (
      perms.testPermission(
        [8, 9, 10, 11, 12, 13],
        ['ViewRescAlertDevicesTechnologyBridge_FlashingLightsConnections'],
      ) && visibleDeviceTypes['Technology Bridge_Flashing Lights']
    );
  else if (device.device_type === 'Technology Bridge_Siren/Giant Voice')
    return (
      perms.testPermission(
        [8, 9, 10, 11, 12, 13],
        ['ViewRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections'],
      ) && visibleDeviceTypes['Technology Bridge_Siren/Giant Voice']
    );
  else if (device.device_type === 'Overwatch VMS')
    return (
      perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewExacqVisionOverwatchVMSConnections']) &&
      visibleDeviceTypes['Overwatch VMS']
    );
  else if (device.device_type === 'Monitoring Station')
    return (
      // Todo: Update permission name when permissions are finalized
      perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUSGSMonitoringStationConnections']) &&
      visibleDeviceTypes['Monitoring Station']
    );
  else if (isBuoyDevice(device))
    return (
      perms.testPermission(
        [8, 9, 10, 11, 12, 13],
        ['ViewRescAlertDevicesBuoyConditionsConnections']
      ) && visibleDeviceTypes['Buoy Conditions']
    );
  else return true;
};
